import type { LinkComponent } from '@fontbold/ui';
import { useRouter } from '@tanstack/react-router';

/** Navigates in-app links client-side; modified clicks keep browser behaviour. */
export const RouterLink: LinkComponent = ({ href, onClick, ...props }) => {
  const router = useRouter();

  return (
    <a
      href={href}
      onClick={(event) => {
        onClick?.(event);

        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        void router.navigate({ href });
      }}
      {...props}
    />
  );
};
